exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.styles__card-link___2h_-e{display:flex;text-decoration:none}.styles__tagged-content-card___1xya-{position:relative;display:flex;flex-flow:column;width:420px;height:350px;background-color:#2c3e50;transition:.5s}.styles__tagged-content-card___1xya-:hover{transform:scale(1.1)}", ""]);

// exports
exports.locals = {
	"card-link": "styles__card-link___2h_-e",
	"tagged-content-card": "styles__tagged-content-card___1xya-"
};